module.exports = __webpack_public_path__ + "img/2023-01-09b_1.6612a297.jpg";